export default __webpack_public_path__ + "static/media/down_arrow_white.1ca74693.png";